import { Box, Typography } from '@mui/material';
import { ErrorMessage, Field, FormikValues, useFormikContext } from 'formik';

import styles from "./InputField.module.scss";

interface IProps {
    title?: string;
    label?: string;
    type?: string;
    name: string;
    className?: string;
    placeholder: string;
    subtitle?: string;
    [x: string]: any;
}

const InputField = (props: IProps) => {
    const { title, label, type = "text", name, className = "mg-b-50", placeholder, subtitle, disabled, ...rest } = props;
    const {values} = useFormikContext<FormikValues>();

    return (
        <Box className={className}>
            {title && <Typography variant={"subtitle1"} component={"h3"} color={"secondary"}
                className={`mg-b-10 ${styles.leftDash}`}>{title}</Typography>}
            {label && <label className="form-label mg-b-20 font-size-14 font-weight-medium">{label} {' '}
                {subtitle && <Typography variant={"subtitle1"} component={"span"} color={"secondary"}>({subtitle})</Typography>}
            </label>
            }
            
            {disabled ? (
                <Typography variant={"body1"} component={"h3"} color={"secondary"}>
                {values[name]}
                </Typography>
            ) : (
                <Field
                type={type}
                className="form-control"
                name={name}
                disabled={disabled}
                placeholder={placeholder}
                {...rest}
                />
            )}

            <ErrorMessage name={name} render={msg => <span className="text-danger font-size-sm">{msg}</span>} />

        </Box>
    )
}

export default InputField